import { createSelector } from 'reselect';
import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericPost } from '@/_shared/types';
import { GenericApiError } from '@/_shared/types/apiError';
import { getCurrentOrganization } from '@/core/state/selectors';
import { API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_EMPLOYEEID_ACCOUNT_ENABLE_PATH_KEY } from '@/swagger/constants/anagraphics-keys';
import { API_POST_EMPLOYER_BY_ID_DISABLE, KEY_POST_EMPLOYER_BY_ID_DISABLE } from '../constants';
import { MOCK_RESPONSE_POST_EMPLOYER_BY_ID_DISABLE } from '../mocks';
import { Employer } from '../types';

type RequestEmployerByIdDisable = GenericPost<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_EMPLOYEEID_ACCOUNT_ENABLE_PATH_KEY
>['request']['path'];

type ResponseEmployerByIdDisable = GenericPost<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_EMPLOYEEID_ACCOUNT_ENABLE_PATH_KEY
>['response']['body'];

export type CallParamsGetEmployerByIdDisable = Omit<
  RequestEmployerByIdDisable,
  'organizationId'
> & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

type CallResponseGetEmployerByIdDisable = ResponseEmployerByIdDisable;

type CallErrorGetEmployerByIdDisable = GenericApiError;

type CallSelectorsGetEmployerByIdDisable = {
  employer: Employer | null;
};

export const postEmployerByIdDisableCall = createGeneralCall<
  CallParamsGetEmployerByIdDisable,
  CallResponseGetEmployerByIdDisable,
  CallErrorGetEmployerByIdDisable,
  CallSelectorsGetEmployerByIdDisable
>({
  id: KEY_POST_EMPLOYER_BY_ID_DISABLE,
  url:
    ({ payload }) =>
    state => {
      const org = getCurrentOrganization(state);
      return API_POST_EMPLOYER_BY_ID_DISABLE(org, payload.employeeId);
    },
  method: 'post',
  successMock: IS_MOCK_ENABLED() ? MOCK_RESPONSE_POST_EMPLOYER_BY_ID_DISABLE : undefined,
  selectors: {
    employer: ({ selectors }) =>
      createSelector(selectors.response, res => (res as Employer) || null),
  },
});
